import React, {useState, useEffect} from "react";

import { FaDownload } from "react-icons/fa6";

import {downloadFileByHash} from '../common/api';

const DownloadButtonPartial = ({item, language, description = null}) => {

  const [series, setSeries] = useState(item.series);
  const [download, setDownload] = useState(false)
  const [loading, setLoading] = useState(false)
  const uniqueSeries = Array.from(new Set(series.map(series => series.name)));
  
  useEffect(() => {
    setDownload(item.download.status);
  })

  
  const downloadFile = async () => {
    let fileName = 'plik';
    setLoading(true);
    console.log(item._id);
    if(item.download.files !== undefined && Object.keys(item.download.files).length > 0){
      const response = await downloadFileByHash(item._id, language);
      if(Object.keys(item.download.files).length === 1){
        fileName = item.download.files[0].name
      }
      else{
        fileName = 'paczka-plikow.zip'
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

    }
    setLoading(false)
  }

  

  let downloadButton = <button disabled={true} className="btn btn-outline-secondary"><FaDownload /> {description}</button>
  if(download){

    let icon = <FaDownload />
    let disabled = false;
    if(loading){
      icon = <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      disabled = true;
    }

    downloadButton = <button disabled={disabled} className="btn btn-success" onClick={downloadFile}>{icon} {description}</button>
  }

  return(
    downloadButton
  )

}

export default DownloadButtonPartial;